import React from 'react';
interface EnquiryFormProps {
  variant: 'general' | 'banquet' | 'room' | 'event';
  title?: string;
}
export function EnquiryForm({
  variant,
  title = 'Send an Enquiry'
}: EnquiryFormProps) {
  return <div className="bg-white p-8 md:p-10 border border-club-border rounded-sm shadow-sm" data-id="element-131">
      <h3 className="font-serif text-3xl mb-6 text-club-green" data-id="element-132">{title}</h3>
      <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-133">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-134">
          <div data-id="element-135">
            <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-136">
              First Name
            </label>
            <input type="text" required className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-137" />
          </div>
          <div data-id="element-138">
            <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-139">
              Last Name
            </label>
            <input type="text" required className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-140" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-141">
          <div data-id="element-142">
            <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-143">
              Email Address
            </label>
            <input type="email" required className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-144" />
          </div>
          <div data-id="element-145">
            <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-146">
              Phone Number
            </label>
            <input type="tel" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-147" />
          </div>
        </div>

        {variant === 'banquet' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-148">
            <div data-id="element-149">
              <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-150">
                Estimated Guests
              </label>
              <input type="number" min="1" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-151" />
            </div>
            <div data-id="element-152">
              <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-153">
                Preferred Date
              </label>
              <input type="date" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-154" />
            </div>
          </div>}

        {variant === 'room' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-155">
            <div data-id="element-156">
              <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-157">
                Check-in Date
              </label>
              <input type="date" required className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-158" />
            </div>
            <div data-id="element-159">
              <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-160">
                Check-out Date
              </label>
              <input type="date" required className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-161" />
            </div>
          </div>}

        <div data-id="element-162">
          <label className="block text-sm font-medium text-club-ink mb-1" data-id="element-163">
            {variant === 'event' ? 'Dietary Requirements / Comments' : 'Message / Additional Details'}
          </label>
          <textarea rows={4} className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-164"></textarea>
        </div>

        <button type="submit" className="btn-primary w-full py-4" data-id="element-165">
          {variant === 'event' ? 'Submit RSVP' : 'Submit Enquiry'}
        </button>
      </form>
    </div>;
}